module.exports = __webpack_public_path__ + "static/media/gavish.16231a22.jpg";